import { render } from "./SetGameOptions.vue?vue&type=template&id=76ac733b&scoped=true"
import script from "./SetGameOptions.vue?vue&type=script&lang=js"
export * from "./SetGameOptions.vue?vue&type=script&lang=js"

import "./SetGameOptions.vue?vue&type=style&index=0&id=76ac733b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76ac733b"]])

export default __exports__